
import './App.less';
import DailyGame from './Views/DailyGame';
// import Tutorial from './Views/Tutorial';
import { lazy, Suspense, useMemo } from 'react';
import useQueryString from 'use-query-string';
import Tutorial from './Views/Tutorial';
import useLocalStorage from './hooks/useLocalStorage';
import useStats from './hooks/useOverallStats';

const MutatleStats = lazy(() => import('./Views/Stats'));

function updateQuery(path: string) {
  window.history.pushState(null, document.title, path);
}

function App() {
  const {longestStreak} = useStats()
  const [useTutorial, setUseTutorial] = useLocalStorage('useTutorial', longestStreak === undefined || longestStreak === 0)
  /* eslint-disable react-hooks/exhaustive-deps */
  const fromTutorial = useMemo(()=>useTutorial, []) // Empty array to only run once, caching initial value
  const qs = useQueryString(
    window.location,
    updateQuery
  );
  const {stats} = qs[0]
  if(stats) return  <Suspense fallback={ <div className={`loading`}><h1>Mutatle</h1></div>}>
    <MutatleStats />
  </Suspense>
  if(useTutorial) return <Tutorial onTutorialComplete={()=>{
    setUseTutorial(false);
    (async ()=>{
      await fetch('https://www.mutatle.com/Mutatle/update_tutorial.php', {
        method: 'POST',
      })
    })();
  }}/>
  return <>
    <DailyGame className={fromTutorial ? "game--from-tutorial" : ""} footer={<Footer/>}/>
  </>

}

function Footer() {
  return <footer>
    <a href='mailto:contact@mutatle.com'>Contact us</a>
    <a href='https://www.mutatle.com/Mutatle/privacy_policy.html' target='_blank'>Privacy Policy</a>
    <span>
      © 2024 Kai Salmon
    </span>
  </footer>
}
export default App;
